module.exports = {
  sanity: {
    projectId:
      process.env.GATSBY_SANITY_PROJECT_ID || "k8qzcdw3",
    dataset: process.env.GATSBY_SANITY_DATASET || "development",
  },
};
